import { render, staticRenderFns } from "./wishlist-span.vue?vue&type=template&id=2a12c875"
import script from "./wishlist-span.vue?vue&type=script&lang=js"
export * from "./wishlist-span.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports